import BaseAnnotationLayer from "./BaseAnnotationLayer";

class DeepBioAnalysisLayer extends BaseAnnotationLayer {
	id = "deep-bio-analysis";
	label = "DeepBio Analysis Layer";
	tools = [];

	hexToRGB = (hex, opacity) =>
		'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length / 3 + '})', 'g'))
			.map(l => parseInt(hex.length % 2 ? l + l : l, 16))
			.concat(opacity || 0.2).join(',') + ')';

	style = feature => {
		this.baseText.setText(feature.get('title'));
		if (feature.getProperties().color) {
			this.baseStyle.getStroke().setColor(feature.getProperties().color);
			this.baseText.getFill().setColor(feature.getProperties().color);
			this.baseStyle.getFill().setColor(this.hexToRGB(feature.getProperties().color))
		}
		this.baseStyle.setText(this.baseText);
		if (feature.getProperties().selected)
			return [this.selectedStyle, this.baseStyle]
		return [this.otherStyle, this.baseStyle]
	}
}

export default DeepBioAnalysisLayer;
